<!--
/*
 * This file is part of peacohrm Inc
 *
 * Copyright (C) 2020 onwards peacohrm Inc
 *
 * This program is free software; you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation; either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see  http://www.gnu.org/licenses
 */
-->

<template>
  <g transform="matrix(2.207717, 0, 0, 2.207717, -184.898178, -250.331589)">
    <circle cx="127.712" cy="143.494" r="27.711" />
    <line
      style="
        fill: none;
        stroke: currentColor;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-miterlimit: 10;
        stroke-width: 19px;
      "
      x1="210.846"
      x2="146.186"
      y1="198.917"
      y2="198.917"
    />
    <path
      d="M 155.423 327.933 C 155.423 333.198 151.146 337.474 145.881 337.474 C 140.856 337.474 136.69 333.576 136.358 328.561 L 132.312 267.873 C 132.146 265.462 130.141 263.577 127.712 263.577 C 125.282 263.577 123.278 265.462 123.112 267.882 L 119.066 328.57 C 118.733 333.576 114.567 337.474 109.542 337.474 C 104.277 337.474 100 333.198 100 327.933 L 100 208.154 C 100 197.947 108.268 189.68 118.475 189.68 L 173.897 189.68 L 173.897 208.154 L 164.66 208.154 C 159.561 208.154 155.423 212.293 155.423 217.392 L 155.423 327.933 Z"
    />
    <polyline
      points="173.897 254.34 293.98 254.34 293.98 143.494 173.897 143.494"
      style="
        fill: none;
        stroke: currentColor;
        stroke-linejoin: round;
        stroke-miterlimit: 10;
        stroke-width: 19px;
      "
    />
    <line
      style="
        fill: none;
        stroke: currentColor;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-miterlimit: 10;
        stroke-width: 19px;
      "
      x1="220.083"
      x2="220.083"
      y1="143.494"
      y2="134.257"
    />
    <line
      style="
        fill: none;
        stroke: currentColor;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-miterlimit: 10;
        stroke-width: 19px;
      "
      x1="183.135"
      x2="201.609"
      y1="328.237"
      y2="254.34"
    />
    <line
      style="
        fill: none;
        stroke: currentColor;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-miterlimit: 10;
        stroke-width: 19px;
      "
      x1="257.032"
      x2="238.558"
      y1="328.237"
      y2="254.34"
    />
  </g>
</template>
